import { useQuery } from '@tanstack/react-query';
import { workflowApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useWorkflowTemplate(templateId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.workflows.templateDetail(String(templateId ?? '')),
    queryFn: ({ signal }) =>
      workflowApiClient.getWorkflowTemplateById(
        templateId!,
        toCancelToken(signal),
      ),
    enabled: templateId != null && !Number.isNaN(templateId),
    staleTime: 0,
    meta: { errorContext: 'workflow template detail' },
  });
}

export function useWorkflowTemplateByType(
  resourceId: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.workflows.templateByType(resourceId ?? ''),
    queryFn: ({ signal }) =>
      workflowApiClient.getWorkflowTemplateByType(
        resourceId!,
        toCancelToken(signal),
      ),
    enabled: !!resourceId,
    staleTime: 0,
    meta: { errorContext: 'workflow template by type' },
  });
}
